// @flow

import React, { Component } from 'react';
import { connect }          from 'react-redux';
import { getTranslate }     from 'react-localize-redux';
import { Link }             from 'react-router-dom';
import urlHelper            from 'helpers/url.helper';
import toolHelper           from 'helpers/tools.helper';
import ApplicationsAPI      from 'api/applicationsAPI';
import { getFile }          from 'actions/s3/fileUpload';
import RoutesURL            from 'routes/routes';
import CompanyRowActivities from './companyRowActivities';
import DirectOffer          from './directOffer';
import moment               from 'moment';
import { createStat }       from 'actions/directOffers';

class CompaniesRows extends Component {

  constructor() {
    super();

    this._openSubTab = this._openSubTab.bind(this);
    this._renderContancts = this._renderContancts.bind(this);
    this._renderRow = this._renderRow.bind(this);
    this._renderPendings = this._renderPendings.bind(this);
    this._createDirectOfferStat = this._createDirectOfferStat.bind(this);
  }

  // here using jquery for slider
  _openSubTab = (e: Object, id: number) => {
    window.$(e.target.closest('.top-info').nextSibling).slideToggle();
    e.target.closest('li').classList.toggle('active');
    ApplicationsAPI.newActivitiesChecked(id);
    e.target.parentElement.childNodes.forEach((item) => {
      if (item.classList.contains('status')) { return item.classList.remove('active') }
    });
  }

  render() {
    const { translate, currentApp } = this.props;
    let correct_pendings = currentApp.pendings_count.slice(0,3-currentApp.app_companies.length)
    const dayDiff = moment().diff(moment(currentApp.created_at), 'days');
    if (dayDiff > 4) { correct_pendings = [] };

    if (currentApp.app_companies.length === 0 && correct_pendings.length === 0) {
      return (
        <div>
          {this._renderCreateNewApp()}
        </div>
      )
    }

    return (
      <div className="search-container">
        <header className="headline type2">
          <h3>{translate('applications.we_found', {count: currentApp.app_companies.length})}</h3>
          <p>{translate('applications.will_contact')}</p>
        </header>
        <ol className="result-list">
          {currentApp.app_companies.map(this._renderRow)}
          {correct_pendings.map(this._renderPendings)}
        </ol>
      </div>
    )
  }


  _renderCreateNewApp = () => {
    const { translate } = this.props;

    return (
      <div className="add-application">
        <h2>{translate('applications.create_new')}</h2>
        <a href={RoutesURL.flow()} className="btn-add">
          {translate('applications.new_app')}
          <i className="fa fa-plus"></i>
        </a>
      </div>
    )
  }

  _renderRow = (appCompany: Object) => {
    const { translate } = this.props;
    const appStatus = JSON.parse(appCompany.access_stats)[5];

    return (
      <li key={appCompany.id} className="active">
        <header className="top-info">
          <div className="logo company-row-logo">
            <Link to={RoutesURL.company_branding(appCompany.company.unique_alias, appCompany.id)}>
              <img src={urlHelper.imageUrl(appCompany.company.meta_logo_large)} alt={appCompany.company.meta_name} className='img-responsive' />
          </Link>
          </div>
          <div className="cell">
            {this._downloads(appCompany)}
          </div>
          <div className={`status ${appCompany.new_activities ? 'active' : ''}`} onClick={(e) => this._openSubTab(e, appCompany.id)}>
            <strong className="text">{translate('applications.current_status')}</strong>
          </div>
          <div className="confirmation" onClick={(e) => this._openSubTab(e, appCompany.id)}>
            <div className={`holder holder-${appStatus}`}>
              <p>{this._getAppStatus(appStatus)}</p>
            </div>
          </div>
          <span className="opener" onClick={(e) => this._openSubTab(e, appCompany.id)}></span>
        </header>
        <div className="detail-info">
          <div className="row">
            <div className="col-md-5 col-xs-4">
              {this._renderContancts(appCompany)}
            </div>
            <div className="col-md-7 col-xs-8">
              <div className="activity">
                <h3>{translate('applications.insurance_activity')}</h3>
                <ul className="list">
                  <CompanyRowActivities appCompany={appCompany}/>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </li>
    )
  }

  _downloads(appCompany) {
    if ( !appCompany.upload_attachments || !appCompany.upload_attachments[0]) { return null; };

    return (
      <ul className="ico-tools">
        <li><a onClick={() => {this._getFile(appCompany.upload_attachments[0].file_hash, true)}} target='_blank' className='butt'><i className="glyphicon glyphicon-download-alt"></i></a></li>
      </ul>
    )
  }

  _getAppStatus(number: number) {
    const { translate } = this.props;
    const statuses =  [
      "Forespørgsel modtaget", //0 not yet touched
      "Forespørgsel åbnet", //1 Awaiting contact
      "Forsøgt kontaktet", //2 tried contact
      "Kontaktet", //3 first follow up after sent
      "Tilbud afgivet", //4 Offer sent
      "Kontaktet", //5 second follow up after sent
      "Tilbud afgivet", //6 Lead won
      "Tilbud afvist"
    ];
    return translate("applications." + statuses[number]);
  }

  _renderPendings = (item) => {
    const { translate } = this.props;

    return (
      <li className="add-insurace" key={item}>
        <a className="add">{translate("applications.third")}</a>
      </li>
    )
  }


  _renderContancts = (appCompany: Object) => {
    if (appCompany.starfish_company_id) {
      return this._renderAgentContacts(appCompany)
    } else {
      return this._renderCompanyContancts(appCompany)
    }
  }

  checkLink(url) {
    return toolHelper.fix_https_url(url);
  }

  _renderCompanyContancts(appCompany) {
    const { translate } = this.props;

    const company = appCompany.company
    const phone = company.meta_phone ? <a className="tel" href={`tel:${company.meta_phone}`}><i className="fa fa-phone"></i><span className="hidden-sm hidden-xs">{company.meta_phone}</span></a> : null
    const mail = company.meta_email ? <a href={`mailto:${company.meta_email}`}><i className="fa fa-envelope"></i><span className="hidden-sm hidden-xs">{company.meta_email}</span></a> : null
    const link = company.meta_link ? <a href={this.checkLink(company.meta_link)}><i className="fa fa-info"></i><span className="hidden-sm hidden-xs">{company.meta_link}</span></a> : null

    return (
      <div className="contacts">
        <header>
          <h3>{company.meta_name}</h3>
        </header>
        <h3><span className="hidden-sm hidden-xs">{translate('applications.will_contact_you')}</span><span className="visible-sm visible-xs">{translate('applications.cont_inf')}</span></h3>
        <p className="hidden-sm hidden-xs"><em>{translate('applications.want_reach')}</em></p>
        <ul>
          <li>{phone}</li>
          <li>{mail}</li>
          <li>{link}</li>
        </ul>
        {this._contactsDownload(appCompany)}
      </div>
    )
  }

  _createDirectOfferStat = (application_company_id: number, webservice_id: number, event_type: string, webservice_name: string) => {
    const { dispatch } = this.props;

    dispatch(createStat(application_company_id, webservice_id, event_type));
  }

  _contactsDownload(appCompany) {
    const { translate } = this.props;

    return (
      <div>
        {appCompany.direct_offer ?
        <ul>
          <DirectOffer
            directOffer={appCompany.direct_offer}
            applicationCompanyId={appCompany.id}
            createDirectOfferStat={this._createDirectOfferStat}
            translate={translate} />
        </ul>
        :
        appCompany.upload_attachments && appCompany.upload_attachments[0] && <footer>
          <span className="ico-status"></span>
          <a onClick={() => {this._getFile(appCompany.upload_attachments[0].file_hash, true)}} target='_blank' className="btn btn-success btn-sm"><i className="glyphicon glyphicon-download-alt"></i><span className="hidden-xs-sm">Download tilbud</span></a>
        </footer>}
      </div>
    )
  }

  _renderAgentContacts(appCompany) {
    const { translate } = this.props;

    const starfish = appCompany.starfish_company
    const phone = starfish.phone ? <a className="tel" href={`tel:${starfish.phone}`}><i className="fa fa-phone"></i><span className="hidden-sm hidden-xs">{starfish.phone}</span></a> : null;
    const mail = starfish.email ? <a href={`mailto:${starfish.email}`}><i className="fa fa-envelope"></i><span className="hidden-sm hidden-xs">{starfish.email}</span></a> : null;
    const link = appCompany.company.meta_link ? <a href={this.checkLink(appCompany.company.meta_link)}><i className="fa fa-info"></i><span className="hidden-sm hidden-xs">{appCompany.company.meta_link}</span></a> : null;

    const imagePath = urlHelper.imageUrl(starfish.avatar_original)
    return (
      <div className="contacts">
        <header>
          <h3>{appCompany.company.meta_name}</h3>
        </header>
        <ul>
          <li className="agent-top">
            <img src={imagePath} alt={appCompany.company.meta_name} className="img-responsive" />
            <div className="agent-text">
              <h3>{starfish.name}</h3>
              <p>{translate('applications.assigned_agent')}</p>
            </div>
          </li>
          <li>{phone}</li>
          <li>{mail}</li>
          <li>{link}</li>
        </ul>
        {this._contactsDownload(appCompany)}
      </div>
    )
  }

  _getFile = (file_hash: string, download: boolean) => {
    getFile(file_hash).then(res => {
      const { status, data } = res;
      if( status !== 200 || data.status === false ) return false;

      window.open(window.URL_API_URL + `/starfish_users_attachments/preview/?file=${file_hash}&token=${data.token}&download=${download.toString()}`, '_blank');
    });
  }

}

const mapStateToProps = state => ({
  translate : getTranslate(state.locale),
  currentApp: state.application.activeApplication
});

export default connect(mapStateToProps)(CompaniesRows);



// WEBPACK FOOTER //
// ./src/components/main/InsuranceInquiry/companiesRows.js